import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Form, Button, Container, Modal } from 'react-bootstrap';
import { useSimaTechContext } from './Context';
import { FetchData } from './DataAccess';
import NavMenu from './NavMenu';

const Section = () => {
  const { dispatch } = useSimaTechContext();
  let navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()

  const ParamsLower = new URLSearchParams();
  for (const [name, value] of searchParams) {
      ParamsLower.append(name.toLowerCase(), value);
  }
  let vehicleIdParam = ParamsLower.get("vehicleid");
  const FetchVehicle = (url, data) => {
    FetchData(url, 'POST', data).then((result) => {
      if (result.errorMessage === null) {
        dispatch({ type: 'vehicleId', payload: result.vehicleId })
        dispatch({ type: 'vehicleName', payload: result.vehicleName })
        navigate("/manager");
      } else {
        alert(result.errorMessage);
      }
    },
      (error) => {
        alert('Kunne ikke finde serveren. Prøv igen senere eller kontakt administratoren.');
      }
    );
  }

  useEffect(() => {
    if (vehicleIdParam) {
      const getVehicleData = 'VehicleId=' + vehicleIdParam;
      FetchVehicle('GetVehicleName', getVehicleData);
    }
  }, [vehicleIdParam]);

  let vehicleNameParam = ParamsLower.get("vehiclename");
  useEffect(() => {
    if (vehicleNameParam) {
      const getVehicleData = 'VehicleName=' + vehicleNameParam;
      FetchVehicle('GetVehicleId', getVehicleData);
    }
  }, [vehicleNameParam]);

  const [vehicleName, setVehicleName] = useState('');

  const handleVehicleNameChange = (value) => {
    setVehicleName(value)
  }

  const handleVehicleName = () => {
    if (vehicleName) {
      const getVehicleData = 'VehicleName=' + vehicleName;
      FetchVehicle('GetVehicleId', getVehicleData);
    }
  }

  return (
    <Modal show={true} animation={false} centered>
      <Modal.Header>
        <Modal.Title>Vogn</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3" controlId="vehicleName">
          <Form.Label>Navn på vogn:</Form.Label>
          <Form.Control type="text" placeholder="" onChange={(e) => handleVehicleNameChange(e.target.value)} />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={() => handleVehicleName()}>OK</Button>
      </Modal.Footer>
    </Modal>
  );
}

function VehicleDialog() {
  return (
    <Container>
      <NavMenu />
      <Section />
    </Container>
  );
}
export default VehicleDialog;